module.exports = __webpack_public_path__ + "static/img/7.252ef6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/7.png
// module id = dDRu
// module chunks = 0